import { usePathname } from '@/i18n/routing';
import { useFirebaseTracking } from '@/providers/FirebaseTrackingProvider/FirebaseTrackingProvider';
import { ConfigurationDetails } from '@/server/api/schemas/configuration.types';
import { User } from '@/server/api/schemas/user.types';

const getScreenName = (pathname: string): string => {
  const screenNameParts = pathname.split('/');

  if (screenNameParts.length === 2 && screenNameParts[1] === '') {
    return 'pitch';
  }

  if (screenNameParts.length === 2 && screenNameParts[1] === 'customer') {
    return 'customer_list';
  }

  if (
    screenNameParts.length === 3 &&
    screenNameParts[1] === 'user' &&
    screenNameParts[2] === 'profile'
  ) {
    return 'profile';
  }

  if (screenNameParts.length === 2 && screenNameParts[1] === 'customer') {
    return 'customer_list';
  }

  if (screenNameParts.length === 3 && screenNameParts[1] === 'customer') {
    return 'customer_details';
  }

  if (screenNameParts.length === 4 && screenNameParts[3] === 'configuration') {
    return 'customer_configuration';
  }

  if (screenNameParts.length === 5 && screenNameParts[3] === 'configuration') {
    return 'concept_configuration';
  }

  if (screenNameParts.length === 6 && screenNameParts[5] === 'choose-concept') {
    return 'choose_concept';
  }

  if (screenNameParts.length === 6 && screenNameParts[5] === 'pitch') {
    return 'pitch_custom';
  }

  return '';
};

export const useNavigationTracking = ({
  user,
  configuration,
}: {
  user?: User;
  configuration?: ConfigurationDetails;
}) => {
  const isInitialised = !!user;
  const pathname = usePathname();
  const { logEvent } = useFirebaseTracking();
  const defaultParameters = {
    user_id: user?.id.toString(),
    user_role: user?.roles ?? undefined,
    tenant_id: user?.tenant?.id ?? undefined,
    customer_id: configuration?.customer?.id?.toString() ?? undefined,
    site_id: configuration?.site?.id ?? undefined,
    config_id: configuration?.id,
    application: 'international',
  };

  const trackNavigationItemClick = (label: string) => {
    if (!isInitialised) {
      return;
    }

    logEvent('navigation_item_click', {
      ...defaultParameters,
      screen_name: getScreenName(pathname),
      navigation_item_label: label,
    });
  };

  return {
    trackNavigationItemClick,
  };
};
